import React, { useContext } from 'react';
import { AppBar, Toolbar, Box, IconButton, Stack, Divider } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AppBreadcrumb from './Breadcrumb';
import { StateContext } from '../context/StateProvider';
import logo from '../../assets/brand/logo.png';
import AppHeaderDropdown from './HeaderDropdown';
import HeaderEjercicio from './HeaderEjercicio';
import HeaderIncidencias from './HeaderIncidencias';
import HeaderTraspasos from './HeaderTraspasos';
import HeaderInventarios from './HeaderInventarios';
import { NotificationToggle } from '../pwa';
import { BotonAvisarPreparacion } from '../../features/ordenes';

/**
 * Header principal de la aplicación (Material-UI, responsive)
 */
export default function Header() {
    const { state, updateState } = useContext(StateContext);

    const estilosAppBar = {
        backgroundColor: '#fff',
        color: '#212529',
        borderBottom: '1px solid #e9ecef',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        // Por debajo del sidebar de CoreUI (z-index 1031) para que el menú
        // móvil se muestre por encima del header
        zIndex: 1029,
    };

    // Modo compacto (header plegado): menú + migas de pan + items reducidos
    if (!state.headerVisible) {
        return (
            <AppBar position="sticky" elevation={0} sx={estilosAppBar}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        minHeight: 38,
                        px: { xs: 1, sm: 2 },
                    }}
                >
                    <IconButton
                        size="small"
                        title="Mostrar/ocultar menú"
                        onClick={() => updateState({ sidebarShow: !state.sidebarShow })}
                        sx={{ color: '#495057' }}
                    >
                        <MenuIcon fontSize="small" />
                    </IconButton>
                    <Box
                        sx={{
                            flex: 1,
                            minWidth: 0,
                            overflow: 'hidden',
                            display: { xs: 'none', sm: 'block' },
                        }}
                    >
                        <AppBreadcrumb />
                    </Box>
                    <Stack
                        direction="row"
                        alignItems="center"
                        spacing={0.25}
                        sx={{ ml: { xs: 'auto', sm: 0 } }}
                    >
                        <HeaderEjercicio compacto />
                        <BotonAvisarPreparacion compacto />
                        <HeaderTraspasos compacto />
                        <HeaderIncidencias compacto />
                        <HeaderInventarios compacto />
                        <NotificationToggle compacto />
                        <AppHeaderDropdown compacto />
                    </Stack>
                </Box>
            </AppBar>
        );
    }

    return (
        <AppBar
            position="sticky"
            elevation={0}
            sx={estilosAppBar}
        >
            <Toolbar
                sx={{
                    minHeight: { xs: 56, md: 64 },
                    px: { xs: 1, sm: 2 },
                    gap: { xs: 0.5, sm: 1 },
                }}
            >
                <IconButton
                    edge="start"
                    title="Mostrar/ocultar menú"
                    onClick={() => updateState({ sidebarShow: !state.sidebarShow })}
                    sx={{ color: '#495057' }}
                >
                    <MenuIcon />
                </IconButton>

                {/* Logo centrado solo en móvil (en escritorio la marca está en el sidebar) */}
                <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                    <Box
                        component="img"
                        src={logo}
                        alt="Mandatelo"
                        sx={{
                            height: { xs: 28, sm: 32 },
                            display: { xs: 'block', md: 'none' },
                        }}
                    />
                </Box>

                <Stack direction="row" alignItems="center" spacing={{ xs: 0.25, sm: 1 }}>
                    <HeaderEjercicio />
                    <Divider
                        orientation="vertical"
                        flexItem
                        sx={{ my: 1.5, display: { xs: 'none', sm: 'block' } }}
                    />
                    <BotonAvisarPreparacion />
                    <HeaderTraspasos />
                    <HeaderIncidencias />
                    <HeaderInventarios />
                    <NotificationToggle />
                    <AppHeaderDropdown />
                </Stack>
            </Toolbar>

            {/* Migas de pan: ocultas en móvil para ganar espacio vertical */}
            <Box
                sx={{
                    display: { xs: 'none', md: 'block' },
                    borderTop: '1px solid #f1f3f5',
                    px: 2,
                    py: 0.75,
                }}
            >
                <AppBreadcrumb />
            </Box>
        </AppBar>
    );
}
